import React from 'react';
import "./videoTimer.css"

const VideoTimer = ({number}) => {
  return (
    <>
    {number === 4 || number === 5?
    <div class="circle">
        <span class="number">{number}</span>
      </div>
      :<div class="circle_after">
      <span class="number_after">{number}</span>
    </div>}
    </>
  
  )
}

export default VideoTimer